import React, { useEffect, useRef, useCallback, memo, useState } from 'react';
import { useField } from 'formik';
import { withFormikFormControl } from '../FormikFormControl';
import BaseEditor from "./BaseFields/BaseEditor";
import {FormPageFieldComponentProps} from "../../types/formPage";


export const RichText = ({extraConfig, ...props}:FormPageFieldComponentProps) => {
    return <BaseEditor {...{extraConfig: {display_as: 'markdown', ...extraConfig}, ...props}}/>

};

export const RichTextFormik = withFormikFormControl()(RichText);

export default RichTextFormik;

